import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faXmark,
  faAngleRight,
} from "@fortawesome/free-solid-svg-icons";
import constants from "../constants/constants";
import { useUserParams } from "../hooks/useUserParams";

const MobileNav = ({ pathname, agentLogo }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [headerPosition, setHeaderPosition] = useState(-100);
  const [headerTiming, setHeaderTiming] = useState(0.8);
  const { getCurrentLogo } = useUserParams();
  const logo = agentLogo || (getCurrentLogo ? getCurrentLogo() : null) || constants.LOGO;

  useEffect(() => {
    // Reset menu state when pathname changes
    setIsMenuOpen(false);
    setHeaderPosition(-100);
    document.body.style.overflow = "auto";
  }, [pathname]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setHeaderPosition(isMenuOpen ? -100 : 0);
    document.body.style.overflow = !isMenuOpen ? "hidden" : "auto";
  };

  const navClick = () => {
    setHeaderPosition(-100);
    setHeaderTiming(0);
    setTimeout(() => {
      setHeaderTiming(0.8);
    }, 100);
    if (typeof window != "undefined" && window.document) {
      document.body.style.overflow = "auto";
    }
  };

  const navItems = [
    { href: "/", label: "Home" },
    { href: "/about", label: "About" },
    { href: "/calculator", label: "Mortgage Calculator" },
    { href: "/listings", label: "Listings" },
    { href: "/evaluation", label: "Free Home Evaluation" },
    { href: "/real-estate-reports", label: "Free Real Estate Reports" },
    { href: "/contact", label: "Contact" },
  ];

  return (
    <>
      <div
        className="relative w-full h-32 z-30 bg-light-grey grid sm:grid-cols-3 grid-cols-[1fr_50%_1fr] items-center"
        style={{
          backgroundColor: constants.RURAL_COLORS.background,
          borderBottom: constants.RURAL_BORDERS.double,
          boxShadow: constants.RURAL_BORDERS.shadow,
        }}
      >
        <div className="z-20 transition-opacity duration-700 ease-in-out w-full h-full absolute bg-white" />
        <button
          onClick={toggleMenu}
          className="z-30 text-2xl px-4 text-mb-red cursor-pointer"
        >
          <FontAwesomeIcon
            icon={isMenuOpen ? faXmark : faBars}
            className="w-6 h-6"
          />
        </button>
        <div className="flex justify-center items-center relative">
            <img
            src={logo}
            alt="Logo"
            width={96}
            height={96}
            className="z-30 h-24"
          />
        </div>
      </div>
      <nav
        style={{
          transition: `translate ${headerTiming}s cubic-bezier(0, .52, 0, 1)`,
          translate: `${headerPosition}vw`,
          border: constants.RURAL_BORDERS.rope,
          borderRadius: "0 18px 18px 0",
          boxShadow: constants.RURAL_BORDERS.shadow,
        }}
        className={`flex flex-col gap-12 px-6 py-9 fixed z-20 w-[75%] h-full child:tracking-wider child:font-bold`}
      >
        {navItems.map((item) => (
          <Link
            key={item.href}
            to={item.href}
            onClick={navClick}
            className={`${pathname === item.href ? "active-page" : ""}`}
            style={{
              color: constants.RURAL_COLORS.primary,
              fontFamily: "serif",
              fontSize: "1.2rem",
            }}
          >
            {item.label}
            {pathname !== item.href && (
              <FontAwesomeIcon
                className="pl-4 w-4 h-4 inline-block"
                icon={faAngleRight}
              />
            )}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default MobileNav;
